import { PropsWithChildren, memo, useMemo } from 'react';

import size from '@/assets/theme/size';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import getDropdownVariant from '@/state/selectors/navigation/get-dropdown-variant';
import getOpenState from '@/state/selectors/navigation/get-open-state';
import isCurrentWidthSmallerThan from '@/state/selectors/window/is-current-width-smaller-than';

const BreadcrumbsContainerComponent: React.FC<PropsWithChildren> = ({
	children,
}) => {
	const isOpen = useStore(getOpenState);
	const dropdownVariant = useStore(getDropdownVariant);
	const isCurrentWidthSmallerThanLaptop = useStore((state) =>
		isCurrentWidthSmallerThan(state, size.laptop),
	);
	const className = useMemo(() => {
		const classes = [
			'dxnav__breadcrumbs-container',
			'dxnav__breadcrumb-hasTitle',
		];
		if (
			isOpen &&
			(dropdownVariant !== 'utility' || isCurrentWidthSmallerThanLaptop)
		)
			classes.push('dxnav__breadcrumbs-container--hidden');
		return classes.join(' ');
	}, [isOpen, dropdownVariant, isCurrentWidthSmallerThanLaptop]);

	return (
		<div className={className}>
			<div className='dxnav__breadcrumbs'>{children}</div>
		</div>
	);
};

const BreadcrumbsContainer = memo(
	withExposer(BreadcrumbsContainerComponent, 'breadcrumbs_container'),
);

export default BreadcrumbsContainer;
